<script>
import BaseImportUpload from './BaseImportUpload.vue'
export default {
  components: {BaseImportUpload},
  props: {
    mediaType: String,
    itemId: Number|null,
    inputName: String|null,
  },
  emits: {
    back: null,
    addListItem: null,
    uploadError: null,
  },
}
</script>

<template>
  <BaseImportUpload
      :media-type="this.mediaType"
      :item-id="this.itemId"
      :input-name="this.inputName"

      @back="this.$emit('back')"
      @uploadError="(error) => {this.$emit('uploadError', error) }"
  >

    <template v-slot:info-text>{{ $t('lists: upload members removal info') }}</template>
    <template v-slot:info-title>{{ $t('lists: removal members list') }}</template>
    <template v-slot:upload-info>{{ $t('lists: upload removal members items') }}</template>

  </BaseImportUpload>
</template>